module.exports = __webpack_public_path__ + "img/network-history-icon.c36b6630.svg";